import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { UiModule } from '@jct/ui';

import { IdentityKeyFieldComponent } from './identity-key-field.component';

@NgModule({
  declarations: [IdentityKeyFieldComponent],
  exports: [IdentityKeyFieldComponent],
  imports: [CommonModule, ReactiveFormsModule, UiModule.forRoot()],
})
export class IdentityKeyFieldModule {}
